$(document).ready(function () {
  // Flag to prevent infinite loop
  var isChangingSelect = false;

  // When a .cstm_option_label is clicked
  $(document).on(
    "click",
    ".product__info-wrapper.grid__item .cstm_label_main .cstm_option_label label",
    function () {
      if (isChangingSelect) return; // Prevent recursion when changing select

      // Get the index of the clicked label
      var index = $(this).closest(".cstm_option_label").index();

      // Find the corresponding <select> option based on the index
      var correspondingOption = $(".footersttextinner select option").eq(index);

      // Check if the variant is sold out
      if (correspondingOption.hasClass("sold-out")) {
        // Variant is sold out, do nothing
        return;
      }

      // Set the flag to true to prevent recursion
      isChangingSelect = true;

      // Trigger the change event on the select dropdown
      $(".footersttextinner select")
        .prop("selectedIndex", index)
        .trigger("change");

      // Reset the flag after a short delay to ensure the change event is finished
      setTimeout(function () {
        isChangingSelect = false;
      }, 0);
    }
  );

  // When an option is selected from the dropdown
  $(".footersttextinner select").on("change", function () {
    if (isChangingSelect) return; // Prevent recursion when clicking label

    // Get the selected option element
    var selectedOption = $(this).find("option:selected");

    // Check if the selected variant is sold out
    if (selectedOption.hasClass("sold-out")) {
      // Variant is sold out, do nothing
      return;
    }

    // Get the index of the selected option
    var index = selectedOption.index();

    // Find the corresponding .cstm_option_label based on the index
    var optionLabel = $(
      ".product__info-wrapper.grid__item .cstm_label_main .cstm_option_label label"
    ).eq(index);

    // Set the flag to true to prevent recursion
    isChangingSelect = true;

    // Trigger the click event on the corresponding .cstm_option_label
    optionLabel.trigger("click");

    // Reset the flag after a short delay to ensure the click event is finished
    setTimeout(function () {
      isChangingSelect = false;
    }, 0);
  });
});

document.querySelectorAll(".Size-\\+\\-Fit").forEach((element) => {
  // Check if the element has direct text content or is entirely empty
  if (!element.children.length && element.textContent.trim() !== "") {
    // This applies when there is direct text content
    element.style.display = "none"; // Or any other styles you need
  } else if (element.children.length) {
    // If it has children elements, you can apply other logic if needed
    element.style.display = "block"; // Example style
  }
});
$(document).ready(function () {
  $(".zorali_worn_row").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

$(document).ready(function () {
  $(".feat_reviews_row").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

$(document).ready(function () {
  $(".timeline-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});
$(document).ready(function () {
  var $slider = $(".contains-card--product.complementary-slider");
  var $progressBar = $(".progress");
  var $progressBarLabel = $(".slider__label");

  // Function to initialize the slider
  function initializeSlider() {
    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 400,
    });
  }

  $slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    var calc = (nextSlide / (slick.slideCount - 1)) * 100;

    $progressBar
      .css("background-size", calc + "% 100%")
      .attr("aria-valuenow", calc);

    $progressBarLabel.text(calc + "% completed");
  });

  // Set a timeout for 2 seconds (2000 milliseconds) before initializing the slider
  setTimeout(initializeSlider, 2000);
});
// Function to check if the viewport width is mobile size
// function isMobile() {
//   return window.innerWidth < 768; // Adjust width based on your breakpoint
// }

// Select the related_product_drawer div and the cart-drawer-items tag
// const relatedDrawer = document.querySelector(".related_product_drawer");
// const cartDrawerItems = document.querySelector("cart-drawer-items");

// Append the related product drawer's content to the cart-drawer-items if on mobile
// if (isMobile() && relatedDrawer && cartDrawerItems) {
//   cartDrawerItems.appendChild(relatedDrawer);
// }
// $(document).ready(function () {
//   // Media query check for 767px or less
//   var mediaQuery = window.matchMedia("(max-width: 767px)");

//   $("span.related_close").click(function () {
//     if (mediaQuery.matches) {
//       // Check if the media query is matched
//       var drawer = $(".related_product_drawer");
//       var currentBottom = parseInt(drawer.css("bottom"), 10);

//       if (currentBottom === -240) {
//         drawer.animate({ bottom: "0" }, 300); // Show
//         $(this).addClass("active"); // Add active class
//       } else {
//         drawer.animate({ bottom: "-240px" }, 300); // Hide
//         $(this).removeClass("active"); // Remove active class
//       }
//     }
//   });
// });
$(document).ready(function () {
  // Media query check
  var mediaQuery = window.matchMedia("(min-width: 768px)");

  $("span.related_close").click(function () {
    if (mediaQuery.matches) {
      // Check if the media query is matched
      var drawer = $(".related_product_drawer");
      var currentLeft = parseInt(drawer.css("left"), 10);

      if (currentLeft === -330) {
        drawer.animate({ left: "-20px" }, 300); // Show
        $(this).addClass("active"); // Add active class
      } else {
        drawer.animate({ left: "-330px" }, 300); // Hide
        $(this).removeClass("active"); // Remove active class
      }
    }
  });
});

$(document).on("click", ".free_drawer_in", function () {
  $(".drawer__inner .product-grid").toggleClass("active");
});
$(document).ready(function () {
  $(".multicolwithtext_right").slick({
    dots: false,
    infinite: true,
    centerMode: false,
    speed: 300,
    slidesToShow: 3,
    vertical: false,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  // Initialize Slick for images
  $("#mushpage_images").slick({
    dots: true,
    infinite: true,
    centerMode: true,
    speed: 300,
    slidesToShow: 6,
    vertical: false,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: "#mushpage_content",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          vertical: true,
        },
      },
    ],
  });

  // Initialize Slick for content
  $("#mushpage_content").slick({
    dots: false,
    infinite: true,
    centerMode: true,
    speed: 300,
    vertical: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: "#mushpage_images",
  });

  // Update content based on image change
  $("#mushpage_images").on("click", ".slick-slide", function (event) {
    var currentSlide = $(this).attr("data-slick-index");

    // Update 'active' class for titles
    $(".mushroom_title_list p").removeClass("active");
    $(
      '.mushroom_title_list p[data-slide-index="' + currentSlide + '"]'
    ).addClass("active");

    // Go to the corresponding slide in the content slider
    $("#mushpage_content").slick("slickGoTo", currentSlide);
  });

  // Make titles clickable
  $(".mushroom_title_list p").on("click", function () {
    var slideIndex = $(this).attr("data-slide-index");

    $(".mushroom_title_list p").removeClass("active");
    $(this).addClass("active");

    // Go to the corresponding slide in the image slider
    $("#mushpage_images").slick("slickGoTo", slideIndex);
    // Go to the corresponding slide in the content slider
    $("#mushpage_content").slick("slickGoTo", slideIndex);
  });
});
$(".faq-group.singles .ac-title").click(function () {
  $(this).parent(".faq-group.singles").toggleClass("acitve");
  // Toggle visibility of .ac-des when .ac-title is clicked
  $(this).next(".ac-des").slideToggle();
});

$(".quick_add_var").click(function () {
  $(this).closest(".variants_option").css("opacity", 1);
});
document.querySelectorAll(".multicolumn-list h3").forEach(function (element) {
  if (element.innerHTML.includes("[icon.5-stars]")) {
    // Define the SVG for one star
    const starSVG = `
              <svg class="w-auto h-full" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.38091 0.0973503C7.10868 -0.0324501 6.7924 -0.0324501 6.52016 0.0973503C6.28482 0.20956 6.15506 0.404385 6.08962 0.511266C6.02198 0.621759 5.95253 0.762511 5.88485 0.899703L4.4477 3.81123L1.23299 4.2811C1.08167 4.30319 0.926395 4.32585 0.800452 4.35614C0.678611 4.38543 0.453338 4.4488 0.274064 4.63803C0.0666695 4.85694 -0.0308653 5.15775 0.00861507 5.45671C0.0427423 5.71513 0.187972 5.89863 0.269439 5.99385C0.35365 6.09227 0.466084 6.20174 0.57566 6.30842L2.90086 8.57316L2.35221 11.772C2.32631 11.9228 2.29974 12.0776 2.28951 12.2068C2.27962 12.3317 2.27006 12.5656 2.39452 12.7948C2.53849 13.0598 2.79441 13.2457 3.09099 13.3007C3.3474 13.3483 3.56692 13.2668 3.68268 13.2188C3.80238 13.1691 3.94132 13.096 4.07676 13.0248L6.95054 11.5135L9.82433 13.0248C9.95976 13.096 10.0987 13.1691 10.2184 13.2188C10.3342 13.2668 10.5537 13.3483 10.8101 13.3007C11.1067 13.2457 11.3626 13.0598 11.5065 12.7948C11.631 12.5656 11.6215 12.3317 11.6116 12.2068C11.6013 12.0776 11.5748 11.9229 11.5489 11.772L11.0002 8.57316L13.3254 6.3084C13.435 6.20172 13.5474 6.09226 13.6316 5.99385C13.7131 5.89863 13.8583 5.71513 13.8925 5.45671C13.9319 5.15775 13.8344 4.85694 13.627 4.63803C13.4477 4.4488 13.2225 4.38543 13.1006 4.35614C12.9747 4.32585 12.8194 4.30319 12.6681 4.2811L9.45338 3.81123L8.01625 0.899753C7.94856 0.762552 7.8791 0.621767 7.81145 0.511266C7.74601 0.404385 7.61626 0.20956 7.38091 0.0973503Z" fill="var(--color-review-stars--hex)"></path>
              </svg>
            `;
    // Repeat the star SVG 5 times
    const fiveStars = starSVG.repeat(5);

    // Replace the shortcode with the repeated SVGs
    element.innerHTML = element.innerHTML.replace("[icon.5-stars]", fiveStars);
  }
});

window.addEventListener("DOMContentLoaded", (event) => {
  const productContainers = document.querySelectorAll(".card__inner");
  if (productContainers) {
    productContainers.forEach((container) => {
      const variantContainer = container.querySelector(".variants_option");
      const addToCartForm = container.querySelector(".add-to-cart-form");
      const variantInput = addToCartForm.querySelector(".selected-variant-id");

      window.addEventListener("click", (event) => {
        if (event.target.tagName === "LI") {
          const variantOptions = variantContainer.querySelectorAll("li");
          variantOptions.forEach((opt) => opt.classList.remove("selected"));
          event.target.classList.add("selected");
          const variantId = event.target.getAttribute("data-variant-id");
          variantInput.value = variantId;
          fetch(addToCartForm.action, {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams(new FormData(addToCartForm)),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error("Network response was not ok");
              }
              return response.text(); // Expecting HTML, not JSON
            })
            .then((data) => {
              console.log("Product added to cart");
              updateCartDrawer(); // Update and open the cart drawer
            })
            .catch((error) => {
              console.error(
                "There was a problem with the fetch operation:",
                error
              );
            });
        }
      });
    });
  }
});

function updateCartDrawer() {
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text()) // Expecting HTML
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const cartDrawer = document.querySelector(".drawer");
      const newContent = html.querySelector("#CartDrawer");

      if (cartDrawer && newContent) {
        cartDrawer.querySelector(".drawer__inner").innerHTML =
          newContent.innerHTML;
        cartDrawer.classList.remove("is-empty");
        cartDrawer.classList.add("active");
      }

      // Open the cart drawer manually
      const cartDrawerElement = document.querySelector("cart-drawer");
      if (cartDrawerElement) {
        cartDrawerElement.classList.add("animate", "active");
        document.body.classList.add("overflow-hidden");
      }
    })
    .catch((e) => console.error(e));
}
document.querySelectorAll(".highlight-tab-button").forEach(function (button) {
  button.onclick = function () {
    // Remove active class from all buttons
    document
      .querySelectorAll(".highlight-tab-button")
      .forEach((btn) => btn.classList.remove("active"));
    this.classList.add("active");

    const description = this.getAttribute("data-description");
    const heading = this.getAttribute("data-heading");
    document.getElementById("highlight-popup-description").textContent =
      description;

    // Append the popup to the target div
    const targetDiv = document.querySelector(".page-width .product--columns");
    if (targetDiv) {
      targetDiv.appendChild(document.getElementById("highlight-popup"));
      document.getElementById("highlight-popup").style.display = "block";
    }

    // Set active class on the corresponding popup header
    const popupHeader = [
      ...document.querySelectorAll(".popup-tab-header"),
    ].find((header) => header.getAttribute("data-heading") === heading);
    if (popupHeader) {
      document
        .querySelectorAll(".popup-tab-header")
        .forEach((h) => h.classList.remove("active"));
      popupHeader.classList.add("active");
    }

    // Update the heading text in the h4 element
    var inside_btn = this.textContent; // Get the text of the clicked button
    $(".highlight_inside_heading h4").text(inside_btn); // Update h4 text
  };
});

const closeButton = document.querySelector(".highlight-close");
if (closeButton) {
  closeButton.onclick = function () {
    document.getElementById("highlight-popup").style.display = "none";
  };
}

// Tab switching functionality in the popup
document.querySelectorAll(".popup-tab-header").forEach(function (header) {
  header.onclick = function () {
    const heading = this.getAttribute("data-heading");
    const button = [...document.querySelectorAll(".highlight-tab-button")].find(
      (btn) => btn.getAttribute("data-heading") === heading
    );

    if (button) {
      // Remove active class from all popup headers
      document
        .querySelectorAll(".popup-tab-header")
        .forEach((h) => h.classList.remove("active"));
      this.classList.add("active");

      const description = button.getAttribute("data-description");
      document.getElementById("highlight-popup-description").textContent =
        description;

      // Set active class on the corresponding main button
      document
        .querySelectorAll(".highlight-tab-button")
        .forEach((btn) => btn.classList.remove("active"));
      button.classList.add("active");

      // Update the heading text in the h4 element
      var inside_btn = button.textContent; // Get the text of the active button
      $(".highlight_inside_heading h4").text(inside_btn); // Update h4 text
    }
  };
});
// let lastScrollY = window.scrollY; // Track last scroll position
// const minOpacity = 0.1; // Minimum opacity
// const maxOpacity = 1; // Maximum opacity
// const section = document.querySelector(".about_believe_art");
// const image = document.querySelector(".image-with-text__media img");

// if (section && image) {
//   // Check if the section and image exist
//   window.addEventListener("scroll", () => {
//     const sectionTop = section.getBoundingClientRect().top;
//     const sectionHeight = section.offsetHeight;
//     const sectionCenter = sectionTop + sectionHeight / 2;
//     const viewportCenter = window.innerHeight / 2;

//     // Calculate opacity based on the section's position relative to the viewport center
//     if (sectionTop < window.innerHeight && sectionTop + sectionHeight > 0) {
//       const currentScrollY = window.scrollY;

//       // Calculate the distance from the viewport center to the section's center
//       const distanceFromCenter = Math.abs(viewportCenter - sectionCenter);

//       // Map this distance to an opacity value: closer to center = higher opacity
//       const maxDistance = window.innerHeight / 2;
//       const opacity = Math.max(
//         minOpacity,
//         maxOpacity - distanceFromCenter / maxDistance
//       );

//       // Apply the calculated opacity
//       image.style.opacity = opacity;

//       // Update last scroll position
//       lastScrollY = currentScrollY;
//     }
//   });
// }
